
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const Container= (props)=>{
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    return(
        <div className={`overflow-hidden ${isRTL ? 'font-almarai' : 'font-inter'}`}>
                {props.children}
        </div>
    );
}
export default Container;